<template>
  <div v-if="objection" class="text-left">
    <h6 class="font-weight-bold cc-text mb-2">{{ objection.titre }}</h6>
    <p v-if="objection.consigne" class="cc-text font-weight-bold mb-2" style="color: #fd7e14">{{ objection.consigne }}</p>
    <p class="cc-text">{{ objection.reponse }}</p>
  </div>
</template>

<script>
import "./coldCall.css";

export default {
  name: "ColdCallObjection",
  props: {
    objection: { type: Object, default: null },
  },
};
</script>
